import { TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { UpdateActorManagerDashboardSettingsMutationDocument } from '@docpace/manager-graphql/dist/urql.types'
import { UpdateActorManagerDashboardSettingsMutationResultFragment } from '@docpace/manager-graphql'

const typedUpdateActorManagerDashboardSettingsMutationDocument = UpdateActorManagerDashboardSettingsMutationDocument as TypedDocumentNode<UpdateActorManagerDashboardSettingsMutationResultFragment>

export function useUpdateActorManagerDashboardSettingsMutation(opts?: useMutation.Options<UpdateActorManagerDashboardSettingsMutationResultFragment>){
    return useMutation(typedUpdateActorManagerDashboardSettingsMutationDocument, opts)
}
